<template>
  <div class="row">
    <div
      :class="
        `col-lg-${
          listFieldsByColumn.length !== 0 ? 12 / listFieldsByColumn.length : 12
        } px-4 mb-4`
      "
      v-for="(columnInput, colIndex) of listFieldsByColumn"
      :key="'row' + colIndex"
    >
      <div
        v-for="(item, index) of columnInput"
        :key="item.model + colIndex + index"
      >
        <div v-if="isDisplayItem(item)">
          <label class="label-title">{{ getDisplayLabel(item) }}</label>
          <p class="detail-info" v-html="getDisplayValue(item.model)"></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* This component is used to detail information of fields by columns*/

export default {
  name: "DetailSectionColumnLayout",
  props: {
    listFields: {
      type: Array,
      default: () => []
    },
    listExcludeFields: {
      type: Array,
      default: () => []
    },
    modelData: Object,
    labelKey: {
      type: String,
      default: "label"
    },
    itemPerColumns: Array
  },
  computed: {
    listFieldsByColumn() {
      return this.listFields.reduce((accResult, cur) => {
        if (accResult.length === 0) {
          return [[cur]];
        }
        const lastEl = accResult[accResult.length - 1];
        if (lastEl.length === this.itemPerColumns[accResult.length - 1]) {
          return [...accResult, [cur]];
        }
        accResult[accResult.length - 1].push(cur);
        return accResult;
      }, []);
    }
  },
  methods: {
    isDisplayItem(item) {
      if (this.listExcludeFields.includes(item.model)) {
        return false;
      }
      if (!this.isItemShow(this.modelData, item)) {
        return false;
      }
      if (this.isMissingField(this.modelData, item.model, item.type)) {
        return false;
      }
      if (item.keyNotNull) {
        if (this.modelData[item.keyNotNull] == null) {
          return false;
        }
      }
      if (item.keyNull) {
        if (this.modelData[item.keyNull] != null) {
          return false;
        }
      }
      return true;
    },
    getDisplayValue(key) {
      const value = this.getValueOfObjectKey(this.modelData, key);
      if (Array.isArray(value)) {
        return value
          .map(item => `<li class="list-detail-item">${item}</li>`)
          .join("");
      }
      if (typeof value === "boolean") {
        return value ? "Yes" : "No";
      }
      return value;
    },
    getDisplayLabel(item) {
      let result = item.label;
      if (item[this.labelKey]) {
        result = item[this.labelKey];
      }
      result = result.trim();
      if (result && result.length > 0) {
        if (result[result.length - 1] === "*") {
          result = result.substring(0, result.length - 1).trim();
        }
      }
      return result;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/DetailSectionColumnLayout.vue